<template>
  <div
    v-if="loginHouseCount > houseCountVariable"
    class="sticky" data-sticky-enable="login-count">
    <div>
      <button
        class="btn unlock_container"
        data-toggle="modal"
        data-target="#register"
        type="button"
      >
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity=".3" d="M4.5 13.335h8V6.668h-8v6.667zm4-4.667c.733 0 1.333.6 1.333 1.333 0 .734-.6 1.334-1.333 1.334s-1.333-.6-1.333-1.334c0-.733.6-1.333 1.333-1.333z" fill="#008489"></path>
          <path d="M12.5 5.335h-.667V4a3.335 3.335 0 0 0-6.666 0v1.334H4.5c-.733 0-1.333.6-1.333 1.333v6.667c0 .733.6 1.333 1.333 1.333h8c.733 0 1.333-.6 1.333-1.333V6.668c0-.733-.6-1.333-1.333-1.333zM6.5 4c0-1.106.893-2 2-2s2 .894 2 2v1.334h-4V4zm6 9.334h-8V6.668h8v6.667zm-4-2c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333s-1.333.6-1.333 1.333c0 .734.6 1.334 1.333 1.334z" fill="#008489"></path>
        </svg>
        <span
          class="subtitle-header"
          v-html="renderMarkdownText"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import markdownToHTML from "../../../../../common/js/components/markdown";
import shared from '../../../../../common/vue/components/search/text/shared';
import Sticky from "../../../../js/components/sticky";

export default {
  name: "adivare-login-house-count-text",
  extends: shared,
  mounted() {
    if (this.loginHouseCount > this.houseCountVariable) {
      new Sticky(); // Initialize Sticky
    }
  },
  computed: {
    houseCountVariable() {

      if (true === this.countExpected && undefined !== this.houseCountExpected) {
        return this.houseCountExpected;
      }

      return this.houseCount;
    },
    renderMarkdownText() {
      const markdownText = this.$t('messages_nl.catalog.nr-results-when-logged-in', {
        'totalResultsAndRentalType': '__' + this.addDotsInNumber(this.loginHouseCount) + ' ' + this.rentalTypeName(this.loginHouseCount) + '__'
      });
      return markdownToHTML(markdownText);
    }
  }
}
</script>
